<template>
  <div :aria-label="lastRefreshed" >
      {{ lastRefreshed }}
  </div>
</template>

<script>
import { mapState } from "vuex";
import { useI18n } from 'vue-i18n';

export default {
  name: 'RefreshLabel',  
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      isRefreshing: false,
      text: 'Refresh'
    };
  },
  methods: {
    refresh() {
      this.isRefreshing = true;
      // Your refresh logic here
      setTimeout(() => {
        this.isRefreshing = false;
      }, 2000);
    }
  },
  computed: {
    ...mapState(["lastRefreshedDateTime"]),
    lastRefreshed() {
      return `${this.t('refreshLabel.lastRefreshed')} ${this.lastRefreshedDateTime.format('HH:mm')}`;
    },
  }
};
</script>

<style scoped>

.label-text {
  font-size: 14px;
  font-weight: 500;
}

.refresh-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
}

.refresh-icon.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>